export const checkUserRole = (currentUser, requiredRole) => {

    // if (currentUser?.role) {
        return currentUser?.role === requiredRole;
    // }else{
    //     return false
    // }
};
